import React from 'react';
import { SelectFieldTW } from '../../../../../../tailwindComponents/selectTW/SelectFieldTW';
import { useBuildOwnerTypeOptions } from './hooks/useBuildOwnerTypeOptions';
import { useOnChangeOwnerType } from './hooks/useOnChangeOwnerType';
import { QuickCloserSet } from './QuickCloserSet';
import { useFormikContext } from 'formik';
import { IDetailsFormData } from './types/IDetailsFormData';

// Select the type of Signing Appointment (buyer, borrower, or seller).
export const SelectAppointmentType: React.FC<{ isCorrection: boolean }> = ({ isCorrection }) => {
  const { initialValues } = useFormikContext<IDetailsFormData>();
  const initialOwnerType = initialValues.ownerType;
  const options = useBuildOwnerTypeOptions(isCorrection, initialOwnerType);
  const onChange = useOnChangeOwnerType();

  return (
    <div className={'flex flex-col'}>
      <SelectFieldTW
        autoComplete="off"
        className={'w-96'}
        isRequired
        disabled={!initialValues.isDigitalScheduling && isCorrection}
        labelText={'Appointment Type'}
        name={'ownerType'}
        onChange={onChange}
        options={options}
      />
      <QuickCloserSet />
    </div>
  );
};
